import React, { useContext } from 'react';
import GlobalContext from '../../contexts/GlobalContext';

const FooterPoweredBySite = (): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const poweredByHubSiteFooterLogoImageWidth = globalContext.liquid.settings.powered_by_hub_site_footer_logo_image_width;
  const poweredByHostName = globalContext.liquid.settings.powered_by_host_name;
  const poweredByHubSiteFooterLogoImage = globalContext.liquid.settings.powered_by_hub_site_footer_logo_image;
  const poweredByHubSiteFooterPositioningText = globalContext.liquid.settings.powered_by_hub_site_footer_positioning_text;
  const poweredByHubSiteFooterAnchorText = globalContext.liquid.settings.powered_by_hub_site_footer_anchor_text;
  const poweredByHubPageUrl = globalContext.liquid.settings.powered_by_hub_page_url;

  return (
    <div className="footer-powered-by-section">
      <div className="footer-powered-by-image-link">
        <div className="footer-powered-by-image">
          <img className="footer-powered-by-img" width={poweredByHubSiteFooterLogoImageWidth} alt={poweredByHostName} src={poweredByHubSiteFooterLogoImage} />
        </div>
        <p className="footer-powered-by-link-text">{ poweredByHubSiteFooterPositioningText }
          <a href={poweredByHubPageUrl} className="footer-powered-by-link">{ poweredByHubSiteFooterAnchorText }</a>
        </p>
      </div>
    </div>
  );
};

export default FooterPoweredBySite;
